module.exports = __webpack_public_path__ + "static/media/toye.3d08ac84.png";